"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userEvents = void 0;
const USER_ACTION = 'user_action';
const APPOINTMENT_RESCHEDULE = 'appointment_reschedule';
exports.userEvents = {
    APPT_SELECT_SLOT: `${USER_ACTION}.${APPOINTMENT_RESCHEDULE}.select_time_slot`,
    APPT_LOAD_MORE: `${USER_ACTION}.${APPOINTMENT_RESCHEDULE}.load_more_appointments`,
    GO_BACK: `${USER_ACTION}.${APPOINTMENT_RESCHEDULE}.go_back`,
    PRINT: `${USER_ACTION}.${APPOINTMENT_RESCHEDULE}.print_appointment`,
    ADD_TO_CALENDAR: `${USER_ACTION}.${APPOINTMENT_RESCHEDULE}.add_to_calendar`,
    APPT_TIME_ERROR_PHONE_NUMBER: `${USER_ACTION}.${APPOINTMENT_RESCHEDULE}.time_error_phone_number`,
    CANCEL_APPOINTMENT_CLICKED: `${USER_ACTION}.${APPOINTMENT_RESCHEDULE}.cancel_appointment_clicked`,
    RESCHEDULE_APPOINTMENT_CLICKED: `${USER_ACTION}.${APPOINTMENT_RESCHEDULE}.reschedule_appointment_clicked`,
    RESCHEDULE_REASON_SELECTED: `${USER_ACTION}.${APPOINTMENT_RESCHEDULE}.reschedule_reason_selected`,
    KEEP_ORIGINAL_APPOINTMENT_CLICKED: `${USER_ACTION}.${APPOINTMENT_RESCHEDULE}.keep_original_appointment_clicked`,
    BOOK_APPOINTMENT_CLICKED: `${USER_ACTION}.${APPOINTMENT_RESCHEDULE}.book_appointment_clicked`,
    APPT_JUMP_TO_DATE_DAY_OF_WEEK: `${USER_ACTION}.${APPOINTMENT_RESCHEDULE}.jump_to_date.change_day_filter`,
    APPT_JUMP_TO_DATE_TIME_OF_DAY: `${USER_ACTION}.${APPOINTMENT_RESCHEDULE}.jump_to_date.change_time_filter`,
    APPT_JUMP_TO_DATE_NO_RESULTS: `${USER_ACTION}.${APPOINTMENT_RESCHEDULE}.jump_to_date.no_results`,
    APPT_NO_RESULTS: `${USER_ACTION}.${APPOINTMENT_RESCHEDULE}.error.provider_schedule.no_results`,
    APPT_JUMP_TO_DATE: `${USER_ACTION}.${APPOINTMENT_RESCHEDULE}.jump_to_date`,
    SCHEDULING_HELP_BANNER_PHONE_NUMBER_CLICKED: `${USER_ACTION}.${APPOINTMENT_RESCHEDULE}.need_help_box.phone_link`
};
//# sourceMappingURL=Tracking.js.map